<template>
	<div id="app">
    <div style="position: fixed; right: 20px; top: 20px; cursor: pointer; font-size: 14px; color: #005AFF; z-index: 99999;" v-show="log" @click="tuichu">退出账号</div>
		<router-view></router-view>
	</div>
</template>

<script>
  import axios from "axios";
	export default {
		name: 'App',
    data() {
      return {
        log:true
      }
    },
    created() {
      this.$router.afterEach(item=>{
        if(item.fullPath == '/login'){
          this.log = false
        }else{
          this.log = true
        }
      })

    },
    methods: {

      tuichu:function(){
        axios.post(`${this.apis}/api/auth/logout`)
        .then(response=> {
          if(response.data.msg.code == 0){
            this.$router.push({
              path:"/login"
            })
          }else{
            this.$message.error(response.data.msg.info);
          }
        })
      }
    }
	}
</script>

<style lang="less">
	@import "~@/assets/all.less";
</style>



// WEBPACK FOOTER //
// src/App.vue